import React from 'react';
import TimeSlotSelection from './TimeSlotSelection';
import useStylesheet from '../hooks/useStylesheet';
import { GEIST_FONT_STYLESHEET_URL, UI_DESIGN_VERSIONS } from '../constants/bookingConst';
import '../css/TimeSlotSelectionV2.css';

/**
 * The guest time slot screen in UI design Version 2 (Config -> Theme -> UI
 * Design): the Court Rates table above the card, locked date chips past the
 * booking window, Geist typography and a fade when a date's slots land.
 *
 * Runs on TimeSlotSelection's booking engine rather than a copy of it — grid
 * rules, selection, promos and pricing stay in one place, and only the
 * presentation differs. Version 2's look lives in TimeSlotSelectionV2.css,
 * scoped under .tss-v2, so Version 1 renders exactly as before.
 *
 * @param {object} props - the same props as TimeSlotSelection
 * @returns {JSX.Element}
 */
function TimeSlotSelectionV2(props) {
  useStylesheet(GEIST_FONT_STYLESHEET_URL);
  return <TimeSlotSelection {...props} design={UI_DESIGN_VERSIONS.V2} />;
}

export default TimeSlotSelectionV2;
